import React from 'react'
import { FormattedMessage } from 'react-intl'

const CookieBanner = ({ navigateTo, acceptCookie }) => {
  return (
    <div className='w-full bg-[#4B5563] flex items-center justify-center'>
        <div className='w-full p-4 max-w-[1400px] flex flex-col md:flex-row gap-4'>
            <p className='text-white text-xs md:pr-12'>
              <FormattedMessage
                id="cookie.text"
                defaultMessage="dresez.com uses cookies and browser storage to save data related to user and its preferences. Also it collects data related to user experience for improving the performance and to deliver the best possible value. By tapping on accept you agree to dresez.com {terms}. See {privacy}."
                values={{
                  terms: (
                    <span onClick={() => navigateTo('terms')} className='text-[#CAE4F1] cursor-pointer'>
                      <FormattedMessage id="common.termsAndConditions" defaultMessage="Terms and Conditions" />
                    </span>
                  ),
                  privacy: (
                    <span onClick={() => navigateTo('privacy')} className='text-[#CAE4F1] cursor-pointer'>
                      <FormattedMessage id="common.privacyPolicy" defaultMessage="Privacy Policy" />
                    </span>
                  ),
                }}
              />
            </p>

            <div className="px-3 text-center flex items-center justify-center">
                <button onClick={acceptCookie} id="btn" className="px-8 bg-green-700 hover:bg-green-800 text-white rounded font-bold text-sm shadow-xl whitespace-nowrap h-[40px]">
                  <FormattedMessage id="cookie.iUnderstand" defaultMessage="I understand" />
                </button>
            </div>
        </div>
    </div>
  )
}

export default CookieBanner
